export function getSelectedAmount({
  isOneProduct,
  isSelectedColor,
  isSelectedSize,
  variantId,
  multipleProductsQuantities,
  isOneSizeProduct
}) {
  const quantitySelectionForSize = multipleProductsQuantities[variantId];
  if (!isOneProduct) {
    return quantitySelectionForSize || 0;
  }
  if (isOneSizeProduct) {
    return isSelectedColor ? 1 : 0;
  }
  if (isSelectedSize && isSelectedColor) {
    return 1;
  }
  return 0;
}